// React
import React from 'react';
import { Col, Row, Card, CardBody, CardHeader } from 'reactstrap';

// Containers Injections
import {
  PageWrapper,
  DashboardWidgets,
  DashboardTopMessage,
  DashboardGoogleMaps,
  DashboardSalesChart,
  DashboardWidgetsReckoning,
  DashboardSalesEvolutionChart,
  DashboardProposalsByPlanChart,
  DashboardDemographicDataChart,
  DashboardProposalSituationsChart,
  DashboardValidationOfProposalsWidgets,
} from '../../containers/componentsInjection';

export const DashboardPage = ({
  user,
  metrics,
  markers,
  offices,
  loading,
  filterOffice,
  setFilterOffice,
  isShowResume,
  isShowProposal,
  isShowForecast,
  isShowByPlan,
  isShowDemo,
  isShowMap,
  isShowBySituation,
  isShowFinances,
  isShowPreProposals,
}) => {
  return (
    <PageWrapper title={'Dashboard'}>
      <Row>
        <Col xs={12} md={12} lg={12}>
          <DashboardTopMessage
            loading={loading}
            offices={offices}
            filterOffice={filterOffice}
            message={user.welcome_message}
            subtitle={user.welcome_subtitle}
            setFilterOffice={setFilterOffice}
          />
        </Col>

        <DashboardWidgets
          loading={loading}
          dataWidget={metrics}
          isShow={isShowResume}
          office={filterOffice.value || ''}
        />

        <DashboardValidationOfProposalsWidgets
          data={metrics}
          loading={loading}
          isShow={isShowPreProposals}
        />
      </Row>

      <DashboardWidgetsReckoning
        office={filterOffice.value || ''}
        isShow={isShowFinances}
      />

      <Row>
        <DashboardSalesChart
          metrics={metrics}
          loading={loading}
          isShow={isShowProposal}
        />

        <DashboardSalesEvolutionChart
          office={filterOffice.value || ''}
          isShow={isShowForecast}
        />

        <DashboardProposalsByPlanChart
          office={filterOffice.value || ''}
          isShow={isShowByPlan}
        />

        <DashboardDemographicDataChart
          office={filterOffice.value || ''}
          isShow={isShowDemo}
        />

        <DashboardProposalSituationsChart
          isShow={isShowBySituation}
          office={filterOffice.value || ''}
        />

        {isShowMap && (
          <Col xs={12} md={12} lg={12}>
            <Card>
              <CardHeader>
                <h4 className="card-title mb-0 flex-grow-1">
                  Quantidade de Associados por Cidade
                </h4>
              </CardHeader>
              <CardBody>
                <DashboardGoogleMaps
                  markers={markers}
                  // loading={loadingMap}
                  apiKey={user.api && user.api.googleMaps}
                />
              </CardBody>
            </Card>
          </Col>
        )}
      </Row>
    </PageWrapper>
  );
};
